<header class="header">
  <button type="button" class="icon-button" aria-label="Abrir o cerrar el menú" (click)="toggleMenu()">
    <fa-icon [icon]="faBars"></fa-icon>
  </button>
  <a class="image-container" routerLink="/home" aria-label="Ir al inicio">
    <img src="./assets/images/logosacich.png" alt="Sacich" class="logo">
  </a>
  <h2 class="title">{{ headerTitle }}</h2>

  <p-menu class="logout-menu" styleClass="header-menu" #menu [model]="items" appendTo="body" [popup]="true">
    <ng-template pTemplate="item" let-item>
      <a class="p-menuitem-link" (click)="item.command && item.command()">
        <span class="p-menuitem-icon">
          <fa-icon [icon]="item.faIcon"></fa-icon>
        </span>
        <span class="p-menuitem-text">{{ item.label }}</span>
      </a>
    </ng-template>
  </p-menu>
  <button type="button" class="user-button" aria-haspopup="menu" aria-label="Menú de usuario" (click)="menu.toggle($event)">
    <span class="avatar" aria-hidden="true">{{ initials }}</span>
    <span class="user-info">
      <span class="user-text">{{ userName }}</span>
      <span class="dept-text">{{ department }}</span>
    </span>
    <fa-icon class="chevron" [icon]="faChevronDown"></fa-icon>
  </button>
</header>
